import * as React from "react"
import NameField from "./name-field"
import CodeField from "./code-field"
import InstructionField from "./instruction-field"
import ConnectorField from "./connector-field"
import { CardModal, CardModalType } from "../../modal"
import * as Model from "../../../model"
import { createLocalAuthority, updateLocalAuthority, createLocalChildAuthority, updateLocalAuthorityChildren } from "../../../service/sfp/local-authorities-service-2"

export default class LocalAuthorityDetail
    extends React.Component<Props, State> {
    private abortController: AbortController = new AbortController

    constructor(props: Readonly<Props>) {
        super(props)

        let connectorSettings: Model.BergerLevrault | null = null,
            code: string | null = null,
            name: string | null = null,
            slug: string | null = null,
            politicalApproach: boolean = false,
            monthlyCountersFillingReminder: boolean = false,
            notificationAfterCountersImport: boolean = false


        if (areUpdateProps(props)) {
            connectorSettings = props.localAuthority.bergerLevrault,
                slug = "",
                code = props.localAuthority.code,
                name = props.localAuthority.name,
                politicalApproach = props.localAuthority.politicalApproach || false,
                monthlyCountersFillingReminder = props.localAuthority.monthlyCountersFillingReminder || false,
                notificationAfterCountersImport = props.localAuthority.notificationAfterCountersImport || false
        }
        if (areEditProps(props)) {
            connectorSettings = props.localAuthority.bergerLevrault,
                slug = "",
                code = props.localAuthority.code,
                name = props.localAuthority.name,
                politicalApproach = props.localAuthority.politicalApproach || false,
                monthlyCountersFillingReminder = props.localAuthority.monthlyCountersFillingReminder || false,
                notificationAfterCountersImport = props.localAuthority.notificationAfterCountersImport || false
        }

        if (areCreateChildProps(props)) {
            slug = props.localAuthority.slug,
                code = "";
            name = "";
            politicalApproach = false;
            monthlyCountersFillingReminder = false;
            notificationAfterCountersImport = false;
        }

        this.state = {
            code,
            instructionId: null,
            name,
            connectorSettings,
            submitting: false,
            slug,
            codeError: false,
            politicalApproach,
            monthlyCountersFillingReminder,
            notificationAfterCountersImport
        }
    }

    componentWillUnmount() {
        this.abortController.abort()
    }

    render() {
        const title = areUpdateProps(this.props) && !areCreateChildProps(this.props) ? `${this.props.localAuthority.name}` : (areCreateChildProps(this.props) ? "Ajouter un budget annexe" : "Ajouter une collectivité")
        return <CardModal
            active={true}
            loading={this.state.submitting}
            title={title}
            type={CardModalType.ValidCancel}
            onClickCloseButton={this.props.onClose}
            onClickFooterButton={(b, e) => this.props.onClose(e)}
            onSubmit={e => this.handleSubmit(e)}>
            <NameField
                loading={this.state.submitting}
                value={this.state.name}
                onChange={name => this.setState({ name })} />

            <CodeField
                loading={this.state.submitting}
                value={this.state.code}
                onChange={code => this.handleCode(code)} />
            <p>{this.state.codeError && '“Le code géographique doit être composé de chiffres uniquement.”'}</p>

            {(areCreateProps(this.props) || areCreateChildProps(this.props)) &&
                <InstructionField
                    loading={this.props.loadingInstructions || this.state.submitting}
                    instructions={this.props.instructions}
                    value={this.state.instructionId}
                    onChange={instructionId => this.setState({ instructionId })} />}

            <ConnectorField
                loading={this.state.submitting}
                settings={this.state.connectorSettings}
                onChange={settings => this.setState({ connectorSettings: settings })} />

            <br />
            <div className="field">
                <label className="label">Notifications par mail</label>
                <span className="field">
                    <span className="control">
                        <label className="checkbox">
                            <input
                                disabled={this.state.submitting}
                                type="checkbox"
                                onChange={() => this.setState({ monthlyCountersFillingReminder: !this.state.monthlyCountersFillingReminder })}
                                checked={this.state.monthlyCountersFillingReminder} />
                            &nbsp;Rappel mensuel du remplissage des compteurs
                        </label>
                    </span>
                </span>
                <br />
                <span className="field">
                    <span className="control">
                        <label className="checkbox">
                            <input
                                disabled={this.state.submitting}
                                type="checkbox"
                                onChange={() => this.setState({ notificationAfterCountersImport: !this.state.notificationAfterCountersImport })}
                                checked={this.state.notificationAfterCountersImport} />
                            &nbsp;Notification aux gestionnaires après import des compteurs
                        </label>
                    </span>
                </span>
            </div>

            <br />
            <div className="field">
                <label className="label">Option</label>
                <span className="field">
                    <span className="control">
                        <label className="checkbox">
                            <input
                                disabled={this.state.submitting}
                                type="checkbox"
                                onChange={() => this.setState({ politicalApproach: !this.state.politicalApproach })}
                                checked={this.state.politicalApproach} />
                            &nbsp;Approche politique
                        </label>
                    </span>
                </span>
            </div>
        </CardModal>
    }

    private createLocalAuthority(props: CreateProps): void {
        if (this.state.code.length > 20) {
            this.setState({ codeError: true })
            return
        }
        const instruction = props.instructions.find(i => i.id === this.state.instructionId)

        createLocalAuthority(
            this.state.name,
            this.state.code,
            instruction,
            this.state.connectorSettings,
            this.state.politicalApproach,
            this.state.monthlyCountersFillingReminder,
            this.state.notificationAfterCountersImport)
            .then(localAuthority => {
                this.setState({ submitting: false }, () => {
                    props.onLocalAuthorityCreated(localAuthority)
                })
            })
            .catch(reason => {
                this.setState({ submitting: false })
            })
    }

    private createLocalChildAuthority(props: CreateChildProps): void {
        if (this.state.code.length > 20) {
            this.setState({ codeError: true })
            return
        }
        const instruction = props.instructions.find(i => i.id === this.state.instructionId)

        createLocalChildAuthority(
            props.localAuthority,
            this.state.slug,
            this.state.name,
            this.state.code,
            instruction,
            this.state.connectorSettings,
            this.state.politicalApproach)
            .then(localAuthority => {
                this.setState({ submitting: false }, () => {
                    props.onLocalChildAuthorityCreated(localAuthority)
                })

            })
            .catch(reason => {
                this.setState({ submitting: false }, () => {
                    props.onLocalChildAuthorityCreated(props.localAuthority)
                })

            })
    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault()
        if (this.state.code.length > 20) {
            this.setState({ codeError: true })
            return
        }
        this.setState({ submitting: true }, () => {
            if (areCreateChildProps(this.props))
                this.createLocalChildAuthority(this.props)
            else if (areUpdateProps(this.props) && this.props.localAuthority.id && !areEditExtraChildProps(this.props))
                this.updateLocalAuthority(this.props)
            else if (areCreateProps(this.props))
                this.createLocalAuthority(this.props)
            else if (areEditExtraChildProps(this.props) && areEditProps(this.props))
                this.updateLocalAuthorityChildren(this.props)

        })
    }
    private handleCode(code): void {
        (code.length <= 20) ? this.setState({ codeError: false, code: code }) : this.setState({ codeError: true, code: code })
    }
    private updateLocalAuthorityChildren(props: EditProps): void {
        if (this.state.code.length > 20) {
            this.setState({ codeError: true })
            return
        }
        updateLocalAuthorityChildren(props.localAuthority,
            this.state.name,
            this.state.code,
            this.state.connectorSettings,
            this.state.politicalApproach,
            this.state.monthlyCountersFillingReminder,
            this.state.notificationAfterCountersImport)
            .then(localAuthority => {
                this.setState({ submitting: false })
                props.onLocalAuthorityExtraChidEdited(props.localAuthority)
                if (props.localAuthority.id == localAuthority.id) {
                    props.updatePA(localAuthority)
                }
            })
            .catch(reason => {
                this.setState({ submitting: false })
            })
    }


    private updateLocalAuthority(props: UpdateProps): void {
        if (this.state.code.length > 20) {
            this.setState({ codeError: true })
            return
        }
        updateLocalAuthority(props.localAuthority,
            this.state.name,
            this.state.code,
            this.state.connectorSettings,
            this.state.politicalApproach,
            this.state.monthlyCountersFillingReminder,
            this.state.notificationAfterCountersImport)
            .then(localAuthority => {
                this.setState({ submitting: false })
                props.onLocalAuthorityUpdated(localAuthority)
                if (props.localAuthority.id == localAuthority.id) {
                    props.updatePA(localAuthority)
                }
            })
            .catch(reason => {
                this.setState({ submitting: false })
            })
    }
}

export type Props = CreateProps | UpdateProps | CreateChildProps | EditChildProps | EditProps

function areCreateProps(props: Props): props is CreateProps {
    return !areUpdateProps(props)
}

function areCreateChildProps(props: Props): props is CreateChildProps {
    return true === (props as CreateChildProps).isChild
}


function areEditExtraChildProps(props: Props): props is CreateChildProps {
    return true === (props as EditChildProps).editExtraLocalAuthority
}

function areUpdateProps(props: Props): props is UpdateProps {
    return undefined !== (props as UpdateProps).localAuthority
}

function areEditProps(props: Props): props is EditProps {
    return undefined !== (props as EditProps).localAuthority
}


interface BaseProps {
    onClose(e: React.SyntheticEvent<Element>): void;
}

interface CreateProps extends BaseProps {
    instructions: Model.Instruction[];
    loadingInstructions: boolean;
    onLocalAuthorityCreated(localAuthority: Model.LocalAuthority): void;
}

interface EditChildProps extends BaseProps {
    isChild: boolean;
    localAuthority: Model.LocalAuthority;
    instructions: Model.Instruction[];
    loadingInstructions: boolean;
    onLocalChildAuthorityCreated(localAuthority: Model.LocalAuthority): void;
    addExtraChildLocalAuthority: boolean
    editExtraLocalAuthority: boolean
}
interface CreateChildProps extends BaseProps {
    isChild: boolean;
    localAuthority: Model.LocalAuthority;
    instructions: Model.Instruction[];
    loadingInstructions: boolean;
    onLocalChildAuthorityCreated(localAuthority: Model.LocalAuthority): void;
}


interface EditProps extends BaseProps {
    localAuthority: Model.LocalAuthority;
    onLocalAuthorityExtraChidEdited(localAuthority: Model.LocalAuthority): void;
    updatePA(localAuthority: Model.LocalAuthority): void;
}
interface UpdateProps extends BaseProps {
    localAuthority: Model.LocalAuthority;
    onLocalAuthorityUpdated(localAuthority: Model.LocalAuthority): void;
    updatePA(localAuthority: Model.LocalAuthority): void;

}

interface State {
    code: string;
    instructionId: number;
    name: string;
    connectorSettings: Model.BergerLevrault | null;
    submitting: boolean;
    slug: string;
    codeError: boolean;
    politicalApproach: boolean;
    monthlyCountersFillingReminder: boolean;
    notificationAfterCountersImport: boolean;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/index.tsx